import { Grid2, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import UncontrolledSearchSelect from "../../../components/UncontrolledSearchSelect";
import { notifyError, notifySuccess } from "../../../utilities/helper";
import CapsTableComponent from "../../../components/CapsTableComponent/CapsTableComponent";
import { addStatusCapService } from "../../../services/studyCapsService";
import { useNavigate } from "react-router-dom";

const SubjectStatusCaps = ({
  access_token,
  statusData,
  userId,
  globalDateFormat,
  setLoad,
  rowData,
  onLoadData,
}) => {
  const navigate = useNavigate();
  console.log("rowData", rowData);
  const [rows, setRows] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    if (rowData && rowData.length > 0) {
      setRows([...rowData]);
    }
  }, [rowData]);

  const addRow = async () => {
    if (selectedStatus !== "") {
      const data = {
        siteId: null,
        patientStatusTypeId: selectedStatus,
        userId: userId,
      };
      try {
        setLoad(true);
        const res = await addStatusCapService(
          access_token,
          userId,
          globalDateFormat,
          data,
        );
        if (
          res?.data?.message === "Cap added successfully!" &&
          res?.data?.status == "201"
        ) {
          notifySuccess("Cap added successfully!");
          onLoadData("study");
        }
        console.log("res29", res);
      } catch (err) {
        console.log("Error : ", err);
        notifyError(err?.message || "Something went wrong!");
        if (err?.status === 401) {
          navigate("/unAuthorize");
        }
      } finally {
        setSelectedStatus("");
        setLoad(false);
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "30px",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <CapsTableComponent
          isFullScreen={false}
          rows={rows}
          setLoad={setLoad}
          tabValue={"study"}
          getOnLoadData={onLoadData}
          setRows={setRows}
        />
        <div
          style={{
            border: "1px solid lightgrey",
            borderRadius: "8px",
            padding: "10px",
            width: "40%",
          }}
        >
          <p className="page-heading">Add A New Subject Status Cap</p>
          <Grid2
            container
            alignItems="center"
            justifyContent={"space-between"}
            gap={1}
          >
            <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
              <div>
                <p
                  className="labelStyles"
                  style={{
                    marginTop: "-10px",
                  }}
                >
                  Status
                </p>

                <UncontrolledSearchSelect
                  data={statusData}
                  optionLabel="patientStatusDescription"
                  optionKey="id"
                  value={selectedStatus}
                  placeholder="Status"
                  onChange={(selectedValue) => {
                    setSelectedStatus(selectedValue);
                  }}
                />
              </div>
            </Grid2>
          </Grid2>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "20px",
            }}
          >
            <Tooltip
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: "14px",
                    padding: "8px 12px",
                  },
                },
              }}
              title={
                selectedStatus !== "" ? "Add Cap" : "Select status to add cap"
              }
            >
              <span>
                <button
                  className={
                    selectedStatus !== "" ? "create-btn" : "disabled-btn"
                  }
                  disabled={selectedStatus === ""}
                  onClick={addRow}
                  style={{
                    pointerEvents: selectedStatus === "" ? "none" : "auto",
                  }}
                >
                  Add Cap
                </button>
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubjectStatusCaps;
